import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

type MessageKey =
  | 'emailLabel'
  | 'descriptionLabel'
  | 'uploadLabel'
  | 'selectLabel'
  | 'taxonomyLabel'
  | 'copyLabel'
  | 'shortTextLabel'
  | 'longTextLabel'
  | 'radioLabel'
  | 'checkboxLabel'
  | 'numberLabel'
  | 'dateLabel'
  | 'formDefaultTitle';

const messages: Record<MessageKey, MessageDescriptor> = defineMessages({
  emailLabel: {
    id: 'defaultForm.emailAddress.label',
    description: 'default label for the submitter email field',
    defaultMessage: 'Email address',
  },
  descriptionLabel: {
    id: 'defaultForm.fileDescription.label',
    description: 'default label for the file description field',
    defaultMessage: 'File description',
  },
  uploadLabel: {
    id: 'defaultForm.uploadZone.label',
    description: 'default label for the upload zone field',
    defaultMessage: 'Upload files',
  },
  selectLabel: {
    id: 'defaultForm.select.label',
    description: 'default label for the dropdown field',
    defaultMessage: 'Dropdown',
  },
  taxonomyLabel: {
    id: 'defaultForm.taxonomy.label',
    description: 'default label for the taxonomy field',
    defaultMessage: 'Taxonomy',
  },
  copyLabel: {
    id: 'defaultForm.copy.label',
    description: 'default copy label for duplicate field ',
    defaultMessage: '(copy) {label}',
  },
  shortTextLabel: {
    id: 'defaultForm.shortText.label',
    description: 'default label for the short text field',
    defaultMessage: 'Short Text',
  },
  longTextLabel: {
    id: 'defaultForm.longText.label',
    description: 'default label for the long text field',
    defaultMessage: 'Long Text',
  },
  radioLabel: {
    id: 'defaultForm.radio.label',
    description: 'default label for the radio field',
    defaultMessage: 'Radio',
  },
  checkboxLabel: {
    id: 'defaultForm.checkbox.label',
    description: 'default label for the checkbox field',
    defaultMessage: 'Checkbox',
  },
  numberLabel: {
    id: 'defaultForm.number.label',
    description: 'default label for the number field',
    defaultMessage: 'Number',
  },
  dateLabel: {
    id: 'defaultForm.date.label',
    description: 'default label for the date field',
    defaultMessage: 'Date',
  },
  formDefaultTitle: {
    id: 'defaultForm.title',
    description: 'Default title for forms when user does not enter a title',
    defaultMessage: 'Untitled Form',
  },
});

export default messages;
